export const IconIdCard = ({ size = 14 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48">
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M3 8h42v32H3zm25 10h12m-12 6h12m-12 6h12"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M12.91 26h6.17a3.91 3.91 0 0 1 3.91 3.91V33H9v-3.09A3.91 3.91 0 0 1 12.91 26zM19 18c0-1.66-1.34-3-3-3s-3 1.34-3 3v2c0 1.66 1.34 3 3 3s3-1.34 3-3z"
      />
    </svg>
  );
};
